export default __webpack_public_path__ + "36c072a3a61e890e7a7be703fb8f674f.svg";